<section id="config-signing-flow" style="padding: 0px 24px">
  <!--Các bên ký hợp đồng-->
  <div class="pt-4">
    <h5>{{ "contract_lot.contract_parties" | translate }}</h5>
    <mat-divider style="left: auto"></mat-divider>
    <br />
    <div class="d-flex justify-content-between" *ngIf="!disabled">
      <div>
        <div style="line-height: 24px;">
          <i class="note">{{ noteWarning }}</i> <br>
        </div>
        <div style="line-height: 24px;" *ngIf="selectedServiceType?.internalFlowNotEdit">
          <i class="note">{{ "form.note_contracting_parties" | translate }}</i>
        </div>
      </div>
      <div>
        <button
          class="mb-2 d-none"
          mat-stroked-button
          color="primary"
          type="button"
          (click)="onChangeUseDataForTemplate()"
          [disabled]="isDisabledAddCreateSide()"
        >
          <mat-icon
            class="mr-0"
            style="vertical-align: middle; width: auto; height: auto"
            >add_circle</mat-icon
          >
          {{ "button.add_create_side" | translate }}
        </button>
      </div>
    </div>
    <nz-table
      #partyRowTable
      nzBordered
      [nzData]="recordPartySign"
      [nzShowPagination]="false"
      [nzFrontPagination]="false"
      class="ant-table-no-placeholder-border-bottom"
    >
      <thead>
        <tr>
          <th class="text-center" nzWidth="10%">
            {{
              "enterprise_contract.panel_document.table_parties.header.order"
                | translate
            }}
          </th>
          <th class="text-center" nzWidth="27.5%">
            {{
              "enterprise_contract.panel_document.table_parties.header.party_name"
                | translate
            }}
          </th>
          <th class="text-center" nzWidth="25%">
            {{
              "enterprise_contract.panel_document.table_parties.header.email"
                | translate
            }}
          </th>
          <th class="text-center" nzWidth="20%" colspan="2">
            {{
              "enterprise_contract.panel_document.table_parties.header.phone"
                | translate
            }}
          </th>
<!--          <th class="text-center" nzWidth="7.5%" *ngIf="!isNotAttestedUser">-->
<!--            {{-->
<!--              "enterprise_contract.panel_document.table_parties.header.sign_no_login"-->
<!--                | translate-->
<!--            }}-->
<!--          </th>-->
          <!-- *ngIf="!disabled" -->
          <th class="text-center" nzWidth="10%"></th>
        </tr>
      </thead>
      <tbody  *ngFor="let data of partyRowTable.data">
        <tr *ngIf="!data.deleteCreateSide" class="editable-row" >
          <!-- TT -->
          <td class="text-center" rowspan="2" *ngIf="!data.isCreatedSide">
            <nz-input-number
              class="td-nz-input"
              [(ngModel)]="data.order"
              [nzMin]="1"
              (ngModelChange)="onChangeOrderOfPartySign()"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="disabled"
            >
            </nz-input-number>
          </td>
          <td class="text-center" *ngIf="data.isCreatedSide">
            <nz-input-number
              class="td-nz-input"
              [(ngModel)]="data.order"
              [nzMin]="1"
              (ngModelChange)="onChangeOrderOfPartySign()"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="disabled"
            >
            </nz-input-number>
          </td>
          <!-- Tên -->
          <td class="word-break-line">
            <div *ngIf="data.isCreatedSide">{{ data.name }}</div>
            <div *ngIf="!data.isCreatedSide">
              {{ "contract_lot.record_party_sign.customer_name" | translate }}
            </div>
          </td>
          <!-- Email -->
          <td class="word-break-line">
            <div *ngIf="data.isCreatedSide">{{ data.email }}</div>
            <div *ngIf="!data.isCreatedSide">
              {{ "contract_lot.record_party_sign.customer_email" | translate }}
            </div>
          </td>

          <!-- Phone -->
          <td class="word-break-line" colspan="2">
            <div *ngIf="data.isCreatedSide">{{ data.phone }}</div>
            <div *ngIf="!data.isCreatedSide">
              {{ "contract_lot.record_party_sign.customer_phone" | translate }}
            </div>
          </td>
          <!--BLTG-->
          <!-- *ngIf="disabled" -->
          <td *ngIf="this.enType!='2'"></td>
          <td class="text-center" *ngIf="data.isCreatedSide && this.enType==='2'" >
            <a class="text-center" nz-popconfirm nzPopconfirmTitle="{{
                  'popup.confirm_delete_party' | translate
                }}" (nzOnConfirm)="
                  onClickDeleteElementRecordParty(data.enterpriseId, data.customerId)
                " [nzIcon]="iconDel" nzCancelText="{{ 'button.cancel' | translate }}"
               nzOkText="{{ 'button.ok' | translate }}">
              <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
            </a>
            <ng-template #iconDel>
              <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
            </ng-template>
          </td>
          <td class="text-center" *ngIf="!data.isCreatedSide" rowspan="2">
          </td>
        </tr>
        <tr *ngIf="!data.isCreatedSide && !data.deleteCreateSide ">
          <td colspan="4" *ngIf="!disabled">
            <label nz-checkbox [(ngModel)]="data.isSignNoLogin" [ngModelOptions]="{ standalone: true }"
                   style="color:rgba(0, 0, 0, 0.87) !important; "
                   *ngIf="!data.isCreatedSide && !isNotAttestedUser" (ngModelChange)="
                                  onSelectCustomerForTemplate(
                                    data.customerId,
                                    data.useDataForTemplate
                                  )
                                "
                   [nzDisabled]="disabled">{{'enterprise_contract.panel_document.table_parties.header.SNL' | translate}}</label>
            <label nz-checkbox [(ngModel)]="data.signConfig" [ngModelOptions]="{ standalone: true }"
                   *ngIf="!data.isCreatedSide" style="color:rgba(0, 0, 0, 0.87) !important; "
                   (ngModelChange)="changeChanKy(data)" [nzDisabled]="disabled"
            >{{'enterprise_contract.panel_document.table_parties.header.DSIS' | translate}}</label>
          </td>
          <td colspan="4" *ngIf="disabled">

            <label nz-checkbox [(ngModel)]="data.isSignNoLogin" [ngModelOptions]="{ standalone: true }"
                   style="color:rgba(0, 0, 0, 0.87) !important; "
                   *ngIf="!data.isCreatedSide && !isNotAttestedUser" (ngModelChange)="
                                  onSelectCustomerForTemplate(
                                    data.customerId,
                                    data.useDataForTemplate
                                  )
                                "
                   class="checkbox-disabled">{{'enterprise_contract.panel_document.table_parties.header.SNL' | translate}}</label>
            <label nz-checkbox [(ngModel)]="data.signConfig" [ngModelOptions]="{ standalone: true }"
                   *ngIf="!data.isCreatedSide" style="color:rgba(0, 0, 0, 0.87) !important; "
                   (ngModelChange)="changeChanKy(data)" class="checkbox-disabled"
            >{{'enterprise_contract.panel_document.table_parties.header.DSIS' | translate}}</label>
          </td>

          <!--          <td class="text-center" *ngIf="!data.isCreatedSide">-->

          <!--          </td>-->

        </tr>
        <tr *ngIf="data.deleteCreateSide">
          <td></td>
          <td [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
            <div class="mat-panel-title mat-panel-title_custom font-color-blue" style="padding-left: 10px">
              {{ "form.add_create_sign" | translate }} &nbsp;
              <div class="d-flex">
                <mat-icon class="mr-0 text-primary" style=" font-size: x-large; cursor: pointer"
                          (click)="comBack()">add_circle_outline
                </mat-icon>
              </div>
            </div>
            <!-- Nz-table set luồng ký / duyệt-->

            <!-- End Nz-table set luồng ký / duyệt-->
          </td>
        </tr>
        <tr *ngIf="data.isCreatedSide ">
          <td
            [attr.rowspan]="(isValidNoUserExist) ?
            RECORD_USER_PERFORM_SIGN.length + 7
            : RECORD_USER_PERFORM_SIGN.length + 6"
            >
          </td>
          <td [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
            <div class="mat-panel-title mat-panel-title_custom font-color-blue" style="padding-left: 10px">
              {{ "form.order_of_approval_signing_contract_unit" | translate }} &nbsp;
              <div class="d-flex" *ngIf="viewMode !== 'view'">
                <mat-icon class="mr-0 text-primary" style=" font-size: x-large; cursor: pointer"
                          matTooltip="{{ 'procedure.choose_procedure_private' | translate }}"
                          (click)="openDialogProcedure(2, $event)">add_circle_outline
                </mat-icon>
              </div>
            </div>
            <!-- Nz-table set luồng ký / duyệt-->

            <!-- End Nz-table set luồng ký / duyệt-->
          </td>
        </tr>

        <tr *ngIf="data.isCreatedSide"
            class="text-primary"
        style="background: #fafafa;"
        >
          <td class="text-center" [attr.colspan]="setColspan(4)" style="padding: 0 !important;">
            <div class="d-flex">
              <div style="width: 50px; max-width: 50px; padding: 6px 8px; border-right: 1px solid #d9d9d9;">
                {{
                "enterprise_contract.panel_document.table_users.header.order"
                | translate
                }}
              </div>
              <div class="d-flex justify-content-center" style="width: 100%; align-items: center;">
                {{
                "enterprise_contract.panel_document.table_users.header.name"
                | translate
                }}
              </div>
            </div>
          </td>
          <td></td>
        </tr>
        <!-- Người dùng phê duyệt hợp đồng -->
        <tr *ngIf="data.isCreatedSide">
          <td [attr.colspan]="setColspan(4)" style="padding: 0 !important;">
          <div class="d-flex align-items-center">
            <div class="col-8 w-100 mat-panel-title_custom font-color-blue" style="padding-left: 10px;">
              {{ "form.contract_approver" | translate}} &nbsp;
            </div>
            <div class="col-2 text-center mat-panel-title_custom font-color-blue d-flex justify-content-center"
                 style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; line-height: 20px;">
              {{"enterprise_contract.panel_document.table_parties.header.sig_cts" | translate}}
            </div>
            <div class="col-2 text-center mat-panel-title_custom font-color-blue d-flex justify-content-center"
              style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; line-height: 20px;">
              {{"enterprise_contract.panel_document.table_parties.header.display_signature" | translate}}
            </div>
          </div>
          </td>
          <td></td>
        </tr>

        <!-- Danh sách người dùng phê đuuyệt hợp đồng -->
        <tr *ngFor="let user of RECORD_USER_PERFORM_SIGN; let i = index"
          [hidden]="!(data.isCreatedSide) || !(user.role != '1' && data.isCreatedSide)">
          <td class="text-center" [attr.colspan]="setColspan(4)" style="padding: 0 !important;">
            <div class="d-flex">
              <div class="col-8 d-flex" style="padding-left: 0;">
                <div class="col-2" style="padding: 15px 0; border-right: 1px solid #d9d9d9; max-width: 80px;">
                  <nz-input-number [disabled]="disabled || selectedServiceType?.internalFlowNotEdit" class="td-nz-input" style="max-width: 60px;" [(ngModel)]="user.order" (ngModelChange)="onChangeOrderApproveSign()" [nzMin]="1"
                  [ngModelOptions]="{ standalone: true }"></nz-input-number> </div>
                <div class="d-flex col-10" style="align-items: center; padding: 0 8px">
                      <div class="editable-cell" *ngIf="user.userId != null">
                        <div *ngIf="user.departmentName" class="row-icon department"><span
                            class="material-icons">apartment</span>{{ user.departmentName }}</div>
                        <div class="row-icon"><span class="material-icons" *ngIf="!user.departmentName">person</span>
                          {{user.name}} - {{user.email}} <span *ngIf="user.userPosition">- {{user.userPosition}}</span></div>
                      </div>
                </div>
              </div>
              <div class="col-2 d-flex justify-content-center" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;">
                <label nz-checkbox [(ngModel)]="user.isSignDigitalCertificate" [nzDisabled]="disabled || selectedServiceType?.internalFlowNotEdit"
                       (ngModelChange)="user.isSignDigitalCertificate ? user.signConfig.showImage = true : user.signConfig.showImage = false; changeCTS($event,user)"
                       [ngModelOptions]="{ standalone: true }">
                </label>
              </div>
              <div class="col-2 d-flex justify-content-center" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;">
                <ng-container *ngIf="user && user.isSignDigitalCertificate">
                  <label nz-checkbox [ngModel]="user?.signConfig?.showImage" [nzDisabled]="disabled || selectedServiceType?.internalFlowNotEdit"
                    (ngModelChange)="user.signConfig.showImage = $event; changeDisplaySignature();"
                    [ngModelOptions]="{ standalone: true }">
                  </label>
                </ng-container>
              </div>
            </div>
          </td>
          <td class="text-center">
            <ng-container *ngIf="!selectedServiceType?.internalFlowNotEdit">
              <a *ngIf="user.userId != null && !disabled" nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
                'popup.confirm_delete_user' | translate
              }}" (nzOnConfirm)="onClickDeleteElementRecordUser(user.userId)"
                      nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                      <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
              </a>
              <ng-template #iconDel>
                <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
              </ng-template>
            </ng-container>
            <ng-container *ngIf="selectedServiceType?.internalFlowNotEdit">
              <a>
                <i class="fa fa-trash disable-delete" aria-hidden="true"></i>
              </a>
            </ng-container>
          </td>
        </tr>

        <!-- Tìm kiếm người dùng phê duyệt hợp đồng -->
        <tr *ngIf="data.isCreatedSide && !disabled && !isCheckApprover">
          <td [attr.colspan]="setColspan(4)" style="padding: 0 !important;">
            <div class="d-flex">
              <div class="col-8 d-flex" style="padding-left: 0;">
                <div style="width: 80px; max-width: 80px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
                </div>
                <div class="d-flex col-10 justify-content-center"
                  style="width: 100%; align-items: center; padding: 0 8px; height: 65px;">
                  <div class="w-100">
                    <nz-input-group [nzSuffix]="suffixUserInput">
                      <input
                        nz-input
                        [(ngModel)]="inputUserValue"
                        (input)="onChangeUserSearch($event)"
                        [nzAutocomplete]="autoUserSearching"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="{{ 'placeholder.name_email_and_posiotion' | translate }}"
                        #autocompleteInput
                        id="inputUser"
                        [disabled]="selectedServiceType?.internalFlowNotEdit"
                      />
                      <nz-autocomplete #autoUserSearching>
                        <nz-auto-option
                          *ngFor="let user of filteredUserOptions"
                          (selectionChange)="autocompleteUserSelected($event, user)"
                          [nzValue]="''"
                          >{{ user.name }}
                          -
                          {{ user.email }} <span *ngIf="user.userPosition">- {{user.userPosition}}</span></nz-auto-option
                        >
                      </nz-autocomplete>
                    </nz-input-group>
                    <ng-template #suffixUserInput>
                      <nz-spin
                        *ngIf="nzCheckLoadingUser"
                        nzSimple
                        [nzIndicator]="indicatorUserInput"
                      ></nz-spin>
                    </ng-template>
                    <ng-template #indicatorUserInput
                      ><i
                        class="nz-icon-font"
                        nz-icon
                        nzType="loading"
                        style="font-size: 24px"
                      ></i
                    ></ng-template>
                  </div>
                </div>
              </div>
              <div class="d-flex col-2" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;"></div>
              <div class="d-flex col-2" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;"></div>
            </div>
          </td>
          <td></td>
        </tr>

        <!-- Người dùng Ký duyệt hợp đồng -->
        <tr *ngIf="data.isCreatedSide">
          <td [attr.colspan]="setColspan(5)" style="padding: 0 !important;">
            <div class="mat-panel-title_custom font-color-blue" style="padding-left: 10px">
              {{ "form.user_signs_and_approves_the_contract" | translate}}
            </div>
          </td>
        </tr>

        <!-- Danh sách người dùng Ký đuuyệt hợp đồng -->
        <tr *ngFor="let user of RECORD_USER_PERFORM_SIGN; let i = index"
          [hidden]="!(data.isCreatedSide) || !(user.role == '1' && data.isCreatedSide)">
          <td class="text-center" [attr.colspan]="setColspan(4)" style="padding: 0 !important;">
            <div class="d-flex">
              <div style="width: 85px; max-width: 85px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
                1
              </div>
              <div class="d-flex" style="width: 100%; align-items: center;  padding: 0 8px">
                <div class="editable-cell" *ngIf="user.userId != null">
                  <div *ngIf="user.departmentName" class="row-icon department"><span
                      class="material-icons">apartment</span>{{ user.departmentName }}</div>
                  <div class="row-icon"><span class="material-icons" *ngIf="!user.departmentName">person</span>
                    {{user.name}} - {{user.email}} <span *ngIf="user.userPosition">- {{user.userPosition}}</span></div>
                </div>
              </div>
            </div>
          </td>
          <td class="text-center">
            <ng-container *ngIf="!selectedServiceType?.internalFlowNotEdit">
                <a *ngIf="user.userId != null && !disabled" nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
                  'popup.confirm_delete_user' | translate
                }}" (nzOnConfirm)="onClickDeleteElementRecordUser(user.userId)"
                        nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                        <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                </a>
                <ng-template #iconDel>
                  <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                </ng-template>
            </ng-container>
            <ng-container *ngIf="selectedServiceType?.internalFlowNotEdit">
              <a>
                <i class="fa fa-trash disable-delete" aria-hidden="true"></i>
              </a>
            </ng-container>
          </td>
        </tr>

        <!-- Tìm kiếm người dùng Ký duyệt hợp đồng -->
        <tr *ngIf="data.isCreatedSide && !isUserSign">
          <td [attr.colspan]="setColspan(4)" style="padding: 0 !important;">
            <div class="d-flex">
              <div style="width: 80px; max-width: 80px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
              </div>
              <div class="d-flex justify-content-center"
                style="width: 100%; align-items: center; padding: 0 8px; height: 65px;">
                <div class="w-100">
                  <nz-input-group [nzSuffix]="suffixUserInput">
                    <input nz-input [(ngModel)]="inputUserSignValue"
                      (input)="onChangeUserSignSearch($event)" [nzAutocomplete]="autoUserSignSearching"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="{{ 'placeholder.name_email_and_posiotion' | translate }}" #autocompleteInput
                      id="inputUserSign"
                      [disabled]="selectedServiceType?.internalFlowNotEdit"
                       />
                    <nz-autocomplete #autoUserSignSearching>
                      <nz-auto-option
                        *ngFor="let user of filteredUserOptions"
                        (selectionChange)="autocompleteUserSignSelected($event, user)"
                        [nzValue]="''"
                        >{{ user.name }}
                        -
                        {{ user.email }} <span *ngIf="user.userPosition">- {{user.userPosition}}</span></nz-auto-option
                      >
                    </nz-autocomplete>
                  </nz-input-group>
                  <ng-template #suffixUserInput>
                    <nz-spin *ngIf="nzCheckLoadingUserSign" nzSimple [nzIndicator]="indicatorUserInput"></nz-spin>
                  </ng-template>
                  <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon nzType="loading"
                      style="font-size: 24px"></i></ng-template>
                </div>
              </div>
            </div>
          </td>
          <td></td>
        </tr>

        <tr
          *ngIf="(isValidNoUserExist) && data.isCreatedSide">
          <td [attr.colspan]="setColspan(5)">
            <mat-error class="font-weight-bold" *ngIf="isValidNoUserExist"
              style="padding-top: 0.5rem">
              {{ "validation.error_user_no_set_up" | translate }}
            </mat-error>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

<!--  <div *ngIf="!isNotAttestedUser" [innerHTML]="'contract_lot.note' | translate" class="pt-4 pb-4"></div>-->
</section>
